import { List } from 'antd';
import { ReactNode } from 'react';
import { useTheme } from 'styled-components';
import { ReactComponent as Empty } from '../../../../assets/icons/listEmpty.svg';
import { LXbody, LXh3 } from '../../texts/lxText';
import Column from '../box/column';
import SizedBox from '../box/sizedBox';

interface LXListProps<T> {
  datas: T[];
  itemBuilder: (item: T, index: number) => ReactNode;
  header?: ReactNode;
  loading?: boolean;
  minHeight?: number;
}

const LXList = <T,>(props: LXListProps<T>) => {
  const theme = useTheme();

  return (
    <List<T>
      style={{ minHeight: props.minHeight }}
      bordered={true}
      header={props.header}
      dataSource={props.datas}
      loading={props.loading}
      locale={{
        emptyText: (
          <Column alignItems="center">
            <SizedBox height={80}></SizedBox>
            <Empty></Empty>
            <SizedBox height={16}></SizedBox>
            <LXh3>{theme.texts.noResultsFound}</LXh3>
            <SizedBox height={8}></SizedBox>
            <LXbody color={theme.colors.caption}>
              {theme.texts.trySerchingForSomethingElse}
            </LXbody>
          </Column>
        ),
      }}
      split={true}
      renderItem={props.itemBuilder}
    ></List>
  );
};

export default LXList;
